import {
  FreeMode,
  Keyboard,
  Mousewheel,
  Navigation,
  Parallax,
  Scrollbar,
  Thumbs,
} from 'swiper/modules';

export const DEFAULTS = {
  swiper: 'swiper',
  simpleSwiper: 'swiper--simple',
  thumbnailsSwiper: 'swiper--thumbnails',
  swiperInitialized: 'swiper-initialized',
  swiperSlide: 'swiper-slide',
  detailedSwiper: 'swiper--detailed',
  modalSwiper: 'swiper--modal',
  slideWrapper: 'swiper-slide__wrapper',
  scrollbar: 'swiper-scrollbar',
  activeSlide: 'swiper-slide-active',
  previousSlide: 'swiper-slide-prev',
  nextButton: 'swiper-button-next',
  prevButton: 'swiper-button-prev',
  playbackButton: 'data-comp-swiper-playback-button',
  slideIndex: 'data-swiper-slide-index',
  linkedSwiper: 'data-comp-swiper-linked',
  remoteController: 'data-comp-swiper-remote',
  remoteControllerSlide: 'data-comp-swiper-remote-index',
};

export const regularMotionConfig = {
  effect: 'slide',
  speed: 800,
};

export const reducedMotionConfig = {
  effect: 'fade',
  speed: 0,
};

const baseConfig = {
  keyboard: {
    enabled: true,
    onlyInViewport: true,
  },
  navigation: {
    nextEl: `.${DEFAULTS.nextButton}`,
    prevEl: `.${DEFAULTS.prevButton}`,
  },
  roundLengths: true,
};

export const simpleConfig = {
  ...baseConfig,
  centeredSlides: true,
  loop: true,
  initialSlide: 0,
  modules: [Keyboard, Navigation, Parallax],
  parallax: true,
  slidesPerView: 1.25,
};

export const detailedConfig = {
  ...baseConfig,
  breakpoints: {
    768: {
      slidesPerView: 1.5,
    },
  },
  centeredSlides: true,
  initialSlide: 0,
  loop: true,
  modules: [Keyboard, Parallax, Navigation, Scrollbar, FreeMode],
  parallax: true,
  scrollbar: {
    el: `.${DEFAULTS.scrollbar}`,
  },
  slidesPerView: 1.3,
  spaceBetween: 16,
};

export const modalConfig = {
  ...baseConfig,
  direction: 'vertical',
  modules: [Navigation, FreeMode, Keyboard, Mousewheel, Thumbs],
  slidesPerView: 'auto',
  freeMode: true,
  mousewheel: {
    enabled: true,
    sensitivity: 1.5,
  },
  rewind: true,
};

export const thumbnailsConfig = {
  ...baseConfig,
  direction: 'vertical',
  modules: [Mousewheel],
  slidesPerView: 4,
  spaceBetween: 12,
  mousewheel: true,
  autoScrollOffset: 1,
};
